import { msg } from '@lingui/core/macro';
import type { BoardProblem, BoardTemplateFileError } from 'modules/template-editor/domain/template-file';
import type { MessageDescriptor } from 'shared/i18n';

/** Why a whole file was not imported, plus the two cases outside the parser: unreadable file, every board skipped. */
export type BoardTemplateImportRejection = BoardTemplateFileError | 'read-failed' | 'no-valid-boards';

export const BOARD_TEMPLATE_IMPORT_REJECTION_TEXT: Record<BoardTemplateImportRejection, MessageDescriptor> = {
  'not-json': msg`Это не файл шаблона трансляции ImGame`,
  'wrong-format': msg`Это не файл шаблона трансляции ImGame`,
  'newer-version': msg`Файл сделан в более новой версии админки — обновите страницу`,
  empty: msg`В файле нет ни одного табло`,
  'no-template-name': msg`У шаблона в файле нет названия`,
  'unknown-sport-type': msg`В файле не указан вид спорта или он неизвестен`,
  'bad-resolution': msg`В файле неверное разрешение шаблона`,
  'read-failed': msg`Не удалось прочитать файл`,
  'no-valid-boards': msg`Ни одно табло в файле не удалось прочитать`,
};

/** Why one board of the file was skipped — shown after its name. */
export const BOARD_PROBLEM_TEXT: Record<BoardProblem, MessageDescriptor> = {
  'not-object': msg`запись в файле повреждена`,
  'no-name': msg`у табло нет названия`,
  'no-objects': msg`нет содержимого холста`,
  'unknown-board-type': msg`такой тип табло эта версия админки не знает`,
  'duplicate-name': msg`табло с таким названием уже есть в файле`,
};
